import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxCardAttachment from "src/components/card/SfxCardAttachment.vue"
import { Attachment } from "src/util/types/dataModels/attachment"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogListAttachmentDelete',
  props: {
  entity: {
    type: String,
    required: true,
  },

  attachments: {
    type: Array as PropType<Attachment[]>,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { t } = useI18n()

const title = t("sfxDialogListAttachmentDelete.title")
const body_warning = t("sfxDialogListAttachmentDelete.body_warning")
const btnCancel = t("sfxButtons.btn_cancel")
const btnRemove = t("sfxButtons.btn_remove")

const body_description = computed(() =>
  props.attachments?.length === 1
    ? t("sfxDialogListAttachmentDelete.body_description", { entity: props.entity }, 1)
    : t("sfxDialogListAttachmentDelete.body_description", { entity: props.entity }, 2)
)

const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin sfx-dialog-border-warning" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 text-negative q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-body1 q-pb-lg" }, {
            default: _withCtx(() => [
              _createElementVNode("span", { innerHTML: body_description.value }, null, 8, _hoisted_1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "text-h5 text-negative q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(body_warning)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "sfx-dialog-list-manager-elements q-pb-none" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.attachments, (attachment, index) => {
                return (_openBlock(), _createBlock(SfxCardAttachment, {
                  key: index,
                  attachment: attachment,
                  entity: props.entity
                }, null, 8, ["attachment", "entity"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                onClick: _unref(onDialogCancel),
                label: _unref(btnCancel),
                class: "col"
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                onClick: _unref(onDialogOK),
                label: _unref(btnRemove),
                class: "col bg-negative"
              }, null, 8, ["onClick", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})